import React, { useCallback, useEffect } from 'react';
import { LogBanner } from './LogBanner';
import './hosLogBanner.scss';
import { useDispatch, useSelector } from 'react-redux';
import {
  getHosFilter,
  getHosFilterFormState,
  getHosLogsUncertified,
  getHosLogsWithMissingInfo,
  getHosLogsWithPendingEdits,
  setFilter,
  setFilterFormState,
} from '../store';
import {
  getProposedMovements,
  getUnassignedMovements,
} from 'src/features/movements/store/movementSelectors';
import { useHistory } from 'react-router-dom';
import { EldMovement, ProposedTrip } from 'src/common/types';

export const HosLogBanners: React.FC = () => {
  const uncertifiedLogs = useSelector(getHosLogsUncertified);
  const hosLogsWithPendingEdits = useSelector(getHosLogsWithPendingEdits);
  const hosLogsWitMissingInfo = useSelector(getHosLogsWithMissingInfo);

  const hosFilterFormState = useSelector(getHosFilterFormState);
  const hosFilterData = useSelector(getHosFilter);
  const unassignedMovements = useSelector(getUnassignedMovements) as EldMovement[];
  const proposedTrips = useSelector(getProposedMovements) as ProposedTrip[];
  const unclaimedMovements = [...unassignedMovements.filter(m => m.endTimestamp), ...proposedTrips];
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      setFilterFormState({
        ...hosFilterData,
      }),
    );
  }, [dispatch, hosFilterData]);

  const filtersObject: { [index: string]: boolean } = {
    ...hosFilterFormState,
  };

  const handleViewLog = useCallback(
    (objKey: string) => (): void => {
      // Reset all the filters
      Object.keys(filtersObject).forEach(key => (filtersObject[key] = false));
      filtersObject[objKey] = true;
      dispatch(setFilterFormState(filtersObject));
      handleApply();
    },
    [filtersObject, dispatch],
  );

  const handleApply = useCallback((): void => {
    dispatch(setFilter(filtersObject));
  }, [dispatch, filtersObject]);

  const history = useHistory();

  return (
    <div className="log-banner-container">
      <LogBanner
        count={uncertifiedLogs.length}
        text="Uncertified Logs"
        onClick={handleViewLog('uncertifiedFilter')}
      />
      <LogBanner
        count={hosLogsWitMissingInfo.length}
        text="Missing Forms"
        onClick={handleViewLog('missingFilter')}
      />
      <LogBanner
        count={hosLogsWithPendingEdits.length}
        text="Pending Edits"
        onClick={handleViewLog('pendingFilter')}
      />
      <LogBanner
        count={unclaimedMovements.length}
        text="Unclaimed Movements"
        onClick={() => history.push('/movements')}
        buttonText="view movements"
      />
    </div>
  );
};
